import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import DatePicker from 'react-bootstrap-date-picker';

class StaffsEmployerTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      staff_id: null,
      date_start: null,
      lista_alunos: [],
      dados: [],
      date: null,
    };

    this.botaoDeletar = this.botaoDeletar.bind(this);
    this.adicionarAluno = this.adicionarAluno.bind(this);
    this.deletar = this.deletar.bind(this);
    this.deletarLinha = this.deletarLinha.bind(this);
    this.handleChangeDatePicker = this.handleChangeDatePicker.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  } 
  handleChangeDatePicker(value, formattedValue) {
    this.setState({
      date_start: value,
      date_start_str: formattedValue,
    });
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  
  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.alunos) && Array.isArray(newProps.lista_alunos)) {
      this.setState({dados: newProps.alunos, lista_alunos: newProps.lista_alunos});
    }
  }

  adicionarAluno(event) {
    event.preventDefault();
    var datasave = {
      employer_id: this.props.employer_id,
      staff_id: this.state.staff_id,
      date_start: this.state.date_start_str,
      type: 'aluno',
    };
    var header = this.refs.request_api.header('application/json');
    this.props.handleAlert('', '', 'open');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/empregador/alunos', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var dados_temp = self.state.dados;
          dados_temp.push(responseJson.data);
          self.setState({dados: dados_temp});
        }
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  botaoDeletar (cell, row, enumObject, index) {
    var variavel = (
      <button className="btn btn-sm btn-danger" value={cell} onClick={this.deletar}>
        <i className="fa fa-fw fa-trash"></i>
      </button>
    );

    return variavel;
  }

  deletar (event) {
    var staff_employer_id = event.currentTarget.value;
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse aluno?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/empregador/aluno/' + staff_employer_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deletarLinha(staff_employer_id);
          }
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  deletarLinha(staff_employer_id) {
    var dados = this.state.dados;
    dados.map(function(dado, index){
      if (dado.id == staff_employer_id) {
        dados.splice(index, 1);
      }
    });
    this.setState({dados: dados});
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Adicionar alunos</h3>
  <hr/>
  <form onSubmit={this.adicionarAluno}>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>Aluno:</label>
          <Select
            className="form-field-name"
            name="staff_id"
            value={this.state.staff_id}
            searchable={true}
            placeholder={'Selecionar aluno'}
            onChange={this.handleSelectChange.bind(this, 'staff_id')}
            options={this.state.lista_alunos}
          />    
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>Data de Início:</label>
          <DatePicker onChange={this.handleChangeDatePicker} monthLabels={['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']} dayLabels={['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']} dateFormat={'DD/MM/YYYY'} placeholder="DD/MM/YYYY" value={this.state.date_start} />
        </div>
      </div>
    </div>  
    <div className="row">
      <div className="col-md-12">
        <div className="form-group">
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-plus"></i> Adicionar Aluno</button>
        </div>
      </div>
    </div>
  </form>  
  <hr/>
  <BootstrapTable data={this.state.dados} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', sizePerPage: 100, noDataText: 'Não há alunos cadastrados'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

    <TableHeaderColumn isKey={true} dataField="aluno_nome" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Aluno</TableHeaderColumn>

    <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Data Inicial</TableHeaderColumn>

    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.botaoDeletar} width='80'>Ações</TableHeaderColumn>

  </BootstrapTable>
</div>
    );
  }
}

export default StaffsEmployerTab;



// WEBPACK FOOTER //
// ./src/Components/Employers/Elements/StaffsEmployerTab.js